export const ARROW_PROVIDER_TYPE = 'Arrow';
export const DEFAULT_PROVIDER_SCHEMA_TYPE = 'String';
export const DEFAULT_ARROW_TYPE = 'utf8';
